/**
 * 下拉选项统一排序：中文 locale 升序 + 数字自然排序（numeric: true）。
 * 用于 el-select / el-option 等展示列表，不改变业务语义（仅调整展示顺序）。
 */

const LABEL_KEYS = [
  "name",
  "label",
  "groupName",
  "title",
  "text",
  "displayName",
];

function compareZhNumeric(left, right) {
  return String(left || "").localeCompare(String(right || ""), "zh-CN", {
    sensitivity: "base",
    numeric: true,
  });
}

/**
 * 按指定字段对对象数组升序排序。
 *
 * @param {Array} items
 * @param {string} [nameKey='name']
 * @returns {Array}
 */
export function sortByName(items, nameKey = "name") {
  if (!Array.isArray(items)) {
    return [];
  }
  return items.slice().sort((a, b) => {
    const left = a && a[nameKey] != null ? String(a[nameKey]) : "";
    const right = b && b[nameKey] != null ? String(b[nameKey]) : "";
    return compareZhNumeric(left, right);
  });
}

/**
 * 字符串 / 原始值数组升序排序。
 *
 * @param {Array} items
 * @returns {Array}
 */
export function sortStrings(items) {
  if (!Array.isArray(items)) {
    return [];
  }
  return items.slice().sort(compareZhNumeric);
}

function detectLabelKey(item) {
  if (item == null || typeof item !== "object") {
    return "name";
  }
  for (const key of LABEL_KEYS) {
    if (item[key] != null && item[key] !== "") {
      return key;
    }
  }
  return "name";
}

/**
 * 下拉选项自动排序：支持对象数组与字符串数组。
 *
 * @param {Array} items
 * @param {string} [labelKey] 指定标签字段；不传则按常见字段自动检测
 * @returns {Array}
 */
export function sortSelectOptions(items, labelKey) {
  if (!Array.isArray(items) || items.length === 0) {
    return items || [];
  }
  const first = items[0];
  if (typeof first === "string" || typeof first === "number") {
    return sortStrings(items);
  }
  const key = labelKey || detectLabelKey(first);
  return sortByName(items, key);
}
